<div class="position-bar-summary-container">
  <div class="position-bar-container">
    @if (derivedPositionClass && derivedPositionClass < (barConfigurations | pure: barRange).min) {
      <div class="out-of-range--left">
        <span>{{ derivedPositionClass }}</span>
      </div>
    }
    @for (item of barConfigurations; track item.positionClass) {
      <div class="position-bar-item-wrapper">
        <div class="position-bar-item position-bar-item--{{ item?.type }}">
          <p class="bold">{{ item.positionClass }}</p>
          @if (item?.label) {
            <p class="type bold">{{ item.label | translate }}</p>
          }
          @if (item.positionClass === seniorManagementPositionClassStart) {
            <div class="senior-management-range-indicator">
              <span>{{ 'mercer-support.dialog.senior-management' | translate }}</span>
            </div>
          }
        </div>
      </div>
    }
    @if (derivedPositionClass && derivedPositionClass > (barConfigurations | pure: barRange).max) {
      <div class="out-of-range--right">
        <span>{{ derivedPositionClass }}</span>
      </div>
    }
  </div>
  <div class="position-bar-info-container">
    @if (proposedPositionClass) {
      <div class="info">
        <div class="circle circle--proposed"></div>
        <span>{{ 'mercer-support.dialog.proposed-pc-by-manager' | translate }}</span>
      </div>
    }
    @if (adjustedPositionClass) {
      <div class="info">
        <div class="circle circle--adjusted"></div>
        <span>{{ 'mercer-support.dialog.adjusted-pc-by-hr' | translate }}</span>
      </div>
    }
    @if (derivedPositionClass) {
      <div class="info">
        <div class="circle circle--recommended"></div>
        <span>{{ 'mercer-support.dialog.recommended-pc-based-on-survey' | translate }}</span>
      </div>
    }
  </div>
</div>
